import ClickAndCollectSearch from './ClickAndCollectSearch';

export default ClickAndCollectSearch;
